import { Component, Input, HostBinding } from '@angular/core';

import * as moment from 'moment-timezone';
import { TranslateService } from '@ngx-translate/core';
import { UnitsPipe } from 'app/shared/pipes/units.pipe';

export interface SummaryMovement {
    active: boolean;
    location: string;
    speed: number;
    speedLimit: number;
    lastMovement: string;
    assetType: string;
}

export interface SummaryTrip {
    distance: number;
    dateStart: string;
    addressStart: string;
}

@Component({
    selector: 'key-details-overview-summary',
    templateUrl: 'details-overview-summary.component.html',
})
export class KeyDetailsOverviewSummaryComponent {
    @Input() movement: SummaryMovement;
    @Input() trip: SummaryTrip;

    @HostBinding('class.details-overview__summary') summaryClass = true;

    constructor(private i18n: TranslateService, private units: UnitsPipe) { }

    getMovementText(data: SummaryMovement): string {
        // TODO: implement better check for static assets when it gets implemented on api client
        // the api should return assetType object which whould have a features object that contains a static check
        if (!data || data.assetType === 'Fixed Asset' || data.assetType === 'Container' ) { return null; }

        if (data.active) {
            if (data.location) {

                if (data.speed > 0) {
                    return this.i18n.instant('STATUS.DETAILS.SUMMARY.MOVING_AT_SPEED_LOCATION', {
                        speed: this.units.transform(data.speed, 'speed'),
                        location: data.location,
                    });
                } else {
                    if (data.lastMovement) {
                        return this.i18n.instant('STATUS.DETAILS.SUMMARY.STOPPED_AT_LOCATION_SINCE_TIME', {
                            time: this.units.transform(data.lastMovement, 'time'),
                            location: data.location,
                        });
                    } else {
                        return this.i18n.instant('STATUS.DETAILS.SUMMARY.STOPPED_AT_LOCATION', {
                            location: data.location,
                        });
                    }
                }
            } else {
                return this.i18n.instant('STATUS.DETAILS.SUMMARY.POSITION_UNKNOWN_AS_NO_GPS_INFORMATION_IS_AVAILABLE');
            }
        } else {
            if (data.lastMovement) {
                return this.i18n.instant(this.isToday(data.lastMovement) ? 'STATUS.DETAILS.SUMMARY.STOPPED_AT_LOCATION' : 'STATUS.DETAILS.SUMMARY.PARKED_AT_LOCATION_SINCE_TIME_ON_DATE', {
                    location: data.location,
                    time: this.units.transform(data.lastMovement, 'time'),
                    date: this.units.transform(data.lastMovement, 'date'),
                });
            } else {
                if (data.location) {
                    return this.i18n.instant('STATUS.DETAILS.SUMMARY.PARKED_AT_LOCATION', { location: data.location });
                } else {
                    return this.i18n.instant('STATUS.DETAILS.SUMMARY.POSITION_UNKNOWN_AS_NO_GPS_INFORMATION_IS_AVAILABLE');
                }
            }
        }
    }

    isToday(date: string) {
        return moment.utc(date, 'YYYY-MM-dd HH:mm:ss').tz(moment.defaultZone.name).isSame(moment(), 'day');
    }
}
